<template>
    <div :class="{'h-11 w-24 mb-0.5 bg-gray-300 animate-pulse' : isSkeleton}">
        <div v-if="!isSkeleton"
             class="flex flex-row -mb-1">
            <span class="text-xl font-bold leading-none text-navy-dark -mt-1">
                
                <span v-if="showPlus && price > 0"
                      class="text-navy-dark
                             font-normal">+</span>

                <span v-if="showPlus && price < 0"
                    class="text-navy-dark
                            font-normal">-</span>
                $
            </span>
            <span 
                data-qa="card_dollar_amount" 
                class="font-heavy text-navy-dark ml-0.5 mr-1 -mt-2 leading-none"
                :class="size === 'small' ? 'text-4xl' : 'text-5xl widescreen:text-6xl '">
                {{ Math.abs(dollar) }}
            </span>
            <div class="flex flex-col text-left">
                <span data-qa="card_cent_amount" class="font-bold leading-none text-navy-dark text-sm whitespace-nowrap">
                    {{ cents }}
                </span>
                <span class="text-xs font-bold leading-none text-navy-dark">{{ frequency }}</span>
                <span
                    v-if="note"
                    class="text-xs leading-none">
                    {{ note }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import IconCircleInfo from "@/atoms/icons/IconCircleInfo"

    export default {
        name: 'PricePerMonth',
        components: {
            IconCircleInfo,
        },
        props: {
            price: {
                type: Number,
                required: true,
            },
            fullPrice: {
                type: Number,
                default: null,
            },
            months: {
                type: Number,
                default: 12,
            },
            note: {
                type: String,
                required: false,
                default: null,
            },
            showPlus: {
                type: Boolean,
                default: false,
            },
            size: {
                type: String,
                default: null,
                validator: val => [
                    null,
                    'small',
                    'large',
                ].includes(val),
            },
            isSkeleton: {
                type: Boolean,
                default: false,
            },
            tooltip: {
                type: String,
                default: '',
            },
            frequency: {
                type: String,
                default: '/mo.',
            },
        },
        computed: {
            getSize(){
                return {
                    small: 'text-3xl',
                    large: 'text-6xl tablet:text-8xl leading-none tablet:leading-16',
                }[this.size] || 'leading-none'
            },
            normalizedPrice() {
                return this.price.toFixed(2).split('.')
            },
            dollar () {
                return this.normalizedPrice[0]
            },
            cents () {
                return this.normalizedPrice[1]
            },
        },
    }
</script>
